export class AudioPlayer {
  private audio: HTMLAudioElement | null = null

  async playSound(urls: string[]): Promise<void> {
    if (urls.length === 0) return

    for (const url of urls) {
      try {
        this.audio = new Audio(url)
        this.audio.volume = 0.7
        
        // Try to play the audio
        await this.audio.play()
        return // Success, exit early
      } catch (error) {
        console.warn(`Failed to play audio from ${url}:`, error)
        continue // Try next URL
      }
    }
    
    console.warn('All audio URLs failed to play')
  }

  stop(): void {
    if (this.audio) {
      this.audio.pause()
      this.audio.currentTime = 0
      this.audio = null
    }
  }
}

export const audioPlayer = new AudioPlayer()